import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile,
} from "react-device-detect";
const CareerBlogs = ({ section }) => {
  const [selectedBlog, setSelectedBlog] = useState({});

  return (
    <section className="container mt-4 mb-4">
      <h3
        style={{
          color: "#AF9763",
          fontWeight: "500",
        }}
        className="text-center mb-4"
      >
        {section.sectionTitle}
      </h3>
      <div class="row row-cols-1 row-cols-md-4 g-4">
        {section.value.length > 0
          ? section.value.slice(0, 4).map((blog, index) => (
              <div class="col">
                <div class="card h-100">
                  <img
                    style={{ maxHeight: "45%" }}
                    src={`${IMAGE_URL}${blog.media[0]}`}
                    class="card-img-top"
                    alt="..."
                  />
                  <div class="card-body">
                    <div className="d-flex justify-content-between align-items-end">
                      <h5
                        class="card-title mb-0"
                        style={{
                          color: "#F6821F",
                          fontSize: "12px",
                          fontWeight: "700",
                          letterSpacing: "2px",
                          textTransform: "uppercase",
                          width: "55%",
                        }}
                      >
                        {blog.title.split(" ").slice(0, 2).join(" ")}
                      </h5>
                      <small className="text-muted">2 hours ago</small>
                    </div>
                    {/* <h5 className="card-title mt-4">{blog.title}</h5> */}
                    <div
                      className="mt-4"
                      dangerouslySetInnerHTML={{
                        __html: blog.description
                          .split(" ")
                          .slice(0, 10)
                          .join(" "),
                      }}
                    ></div>
                    {/* <p class="card-text text-muted">{blog.short_description}</p> */}
                    <div
                      className="d-flex justify-content-center align-items-center w-50 rounded p-2 mt-3"
                      style={{
                        textDecoration: "none",
                        backgroundColor: "#AF9763",
                      }}
                      type="button"
                      onClick={() => setSelectedBlog(blog)}
                      data-bs-toggle="modal"
                      data-bs-target="#blogModal"
                    >
                      {/* <Link
                        
                        to={`/pages/blog/${blog.id}`}
                      > */}
                      <p
                        style={{
                          color: "#ffffff",
                          fontSize: "14px",
                          fontWeight: "500",
                          textAlign: "center",
                        }}
                      >
                        Read more
                      </p>
                      {/* <img
                        className="ms-3"
                        src="/assets/images/arrow-right.png"
                        alt=""
                      /> */}
                      {/* </Link> */}
                    </div>
                  </div>
                </div>
              </div>
            ))
          : ""}
        <div
          class="modal fade"
          id="blogModal"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div
              class="jobModalContent modal-content mt-5"
              style={{ maxHeight: isBrowser ? "700px" : "500px" }}
            >
              <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">
                  {selectedBlog.title}
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body d-flex flex-column justify-content-between align-items-start">
                <div className="w-100 mb-4">
                  {selectedBlog.media ? (
                    <img
                      src={`${IMAGE_URL}${selectedBlog.media[0]}`}
                      alt=""
                      className="img-fluid w-100 rounded"
                      style={{
                        maxHeight: "250px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  ) : (
                    <img
                      src="/assets/images/united_logo.png"
                      alt=""
                      className="img-fluid w-100 rounded"
                      style={{
                        maxHeight: "250px",
                        objectFit: "cover",
                        objectPosition: "center",
                      }}
                    />
                  )}
                </div>
                <div
                  className=""
                  dangerouslySetInnerHTML={{ __html: selectedBlog.description }}
                ></div>
              </div>
              <div class="modal-footer">
                <button
                  class="px-3 py-2"
                  type="button"
                  data-bs-dismiss="modal"
                  style={{
                    borderRadius: "5px",
                    backgroundColor: "#AF9763",
                    border: "none",
                    color: "white",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareerBlogs;



// WEBPACK FOOTER //
// ./src/component/frontend/CareerBlogs.js